(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lumera-system"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('lumera-section')){
    class LumeraSection extends HTMLElement{
      connectedCallback(){
        if(this.lmReady)return;
        this.lmReady=true;
        this.abort=new AbortController();
        this.motionQuery=matchMedia('(prefers-reduced-motion: reduce)');
        this.paused=false;
        this.activeVideos=new Set();
        this.animations=new Set();
        const signal=this.abort.signal;
        this.motionQuery.addEventListener('change',()=>this.syncMotion(),{signal});
        this.querySelector('[data-lm-motion]')?.addEventListener('click',()=>{
          this.paused=!this.paused;this.syncMotion();
          const button=this.querySelector('[data-lm-motion]');
          button.setAttribute('aria-pressed',String(this.paused));button.textContent=this.paused?button.dataset.resume:button.dataset.pause;
        },{signal});
        this.querySelectorAll('[data-lm-play]').forEach(button=>button.addEventListener('click',()=>{
          const video=button.parentElement.querySelector('video');
          if(video){video.dataset.userPlay='true';this.playVideo(video);}
        },{signal}));
        if('IntersectionObserver' in window){
          this.videoObserver=new IntersectionObserver(entries=>entries.forEach(entry=>{
            if(entry.isIntersecting){this.activeVideos.add(entry.target);this.playVideo(entry.target);}
            else{this.activeVideos.delete(entry.target);entry.target.pause();}
          }),{threshold:.12});
          this.querySelectorAll('[data-lm-video]').forEach(video=>this.videoObserver.observe(video));
          this.revealObserver=new IntersectionObserver(entries=>entries.forEach(entry=>{
            if(!entry.isIntersecting)return;
            if(this.canAnimate&&!window.Shopify?.designMode){
              const animation=entry.target.animate([{opacity:.15,transform:'translateY(24px)'},{opacity:1,transform:'translateY(0)'}],{duration:850,easing:'cubic-bezier(.2,.7,.2,1)',delay:Math.min(Number(entry.target.dataset.lmDelay||0),240)});
              this.animations.add(animation);animation.onfinish=()=>this.animations.delete(animation);
            }
            this.revealObserver.unobserve(entry.target);
          }),{threshold:.08});
          this.querySelectorAll('[data-lm-reveal]').forEach(item=>this.revealObserver.observe(item));
        }else{
          this.querySelectorAll('[data-lm-video]').forEach(video=>{this.activeVideos.add(video);this.playVideo(video);});
        }
        this.addEventListener('pointerdown',()=>this.retryVideos(),{signal,passive:true});
        document.addEventListener('visibilitychange',()=>{
          if(document.hidden)this.activeVideos.forEach(video=>video.pause());else this.retryVideos();
        },{signal});
        const track=this.querySelector('[data-lm-track]');
        if(track){
          const controls=this.querySelector('[data-lm-controls]');
          const previous=controls?.querySelector('[data-lm-prev]');
          const next=controls?.querySelector('[data-lm-next]');
          const refresh=()=>{
            const overflow=track.scrollWidth-track.clientWidth>4;
            if(controls)controls.hidden=!overflow;
            if(previous)previous.disabled=track.scrollLeft<3;
            if(next)next.disabled=track.scrollLeft>=track.scrollWidth-track.clientWidth-3;
          };
          const move=direction=>{
            const card=track.firstElementChild;if(!card)return;
            const gap=parseFloat(getComputedStyle(track).columnGap)||16;
            track.scrollBy({left:direction*(card.getBoundingClientRect().width+gap),behavior:this.motionQuery.matches?'auto':'smooth'});
          };
          previous?.addEventListener('click',()=>move(-1),{signal});
          next?.addEventListener('click',()=>move(1),{signal});
          track.addEventListener('scroll',refresh,{signal,passive:true});
          track.addEventListener('keydown',event=>{
            if(event.target!==track)return;
            if(event.key==='ArrowRight'||event.key==='ArrowLeft'){event.preventDefault();move(event.key==='ArrowRight'?1:-1);}
          },{signal});
          if('ResizeObserver' in window){this.resizeObserver=new ResizeObserver(refresh);this.resizeObserver.observe(track);}
          refresh();
          document.addEventListener('shopify:block:select',event=>{
            if(this.contains(event.target)){const card=event.target.closest('[data-lm-card]');if(card)track.scrollTo({left:card.offsetLeft-track.offsetLeft,behavior:'auto'});}
          },{signal});
        }
        if(this.classList.contains('lm-hero')){
          const update=()=>{
            this.frame=0;
            if(!this.canAnimate||innerWidth<750)return;
            const bounds=this.getBoundingClientRect();
            if(bounds.bottom<0||bounds.top>innerHeight)return;
            const progress=Math.min(1,Math.max(0,-bounds.top/bounds.height));
            this.style.setProperty('--lm-progress',String(.12+progress*.88));
            const visual=this.querySelector('.lm-hero__visual');
            if(visual)visual.style.transform=`translate3d(0,${progress*45}px,0) scale(${1.035+progress*.045})`;
          };
          this.scrollUpdate=()=>{if(!this.frame)this.frame=requestAnimationFrame(update);};
          window.addEventListener('scroll',this.scrollUpdate,{signal,passive:true});
          window.addEventListener('resize',this.scrollUpdate,{signal,passive:true});
          update();
        }
        this.syncMotion();
      }
      get canAnimate(){return this.dataset.motion!=='false'&&!this.motionQuery.matches&&!this.paused;}
      async playVideo(video){
        const button=video.parentElement.querySelector('[data-lm-play]');
        if(document.hidden)return;
        if(!this.canAnimate&&video.dataset.userPlay!=='true'){video.pause();if(button)button.hidden=false;return;}
        if(video.dataset.loaded!=='true'){
          const sources=[...video.querySelectorAll('source[data-src]')];
          sources.forEach(source=>{source.src=source.dataset.src;});
          video.dataset.loaded='true';video.load();
        }
        video.muted=true;video.defaultMuted=true;video.playsInline=true;
        try{await video.play();if(button)button.hidden=true;}catch(error){if(error.name!=='AbortError'&&button)button.hidden=false;}
      }
      retryVideos(){this.activeVideos.forEach(video=>{if(video.paused)this.playVideo(video);});}
      syncMotion(){
        if(!this.canAnimate){
          this.animations.forEach(animation=>animation.finish());
          this.activeVideos.forEach(video=>{delete video.dataset.userPlay;video.pause();const button=video.parentElement.querySelector('[data-lm-play]');if(button)button.hidden=false;});
          this.querySelector('.lm-hero__visual')?.style.removeProperty('transform');
        }else this.retryVideos();
      }
      disconnectedCallback(){
        this.abort?.abort();this.videoObserver?.disconnect();this.revealObserver?.disconnect();this.resizeObserver?.disconnect();
        if(this.frame)cancelAnimationFrame(this.frame);
        this.animations?.forEach(animation=>animation.cancel());this.activeVideos?.forEach(video=>video.pause());this.lmReady=false;
      }
    }
    customElements.define('lumera-section',LumeraSection);
  }
  } catch(e) { console.error(e); }
})();

})();
